<template>
  <div>
    <v-row class="header" v-show="!$storeDemandeBourse.TokenExtranet">
      <v-col cols="4">
        <v-img
          src="@/assets/logo_white.svg"
          contain
          max-height="125"
          position="left"
        ></v-img>
      </v-col>
      <v-col cols="4">
        <h2>Candidature bourse</h2>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>
    <v-main v-if="!confirmation" id="cp">
      <v-dialog v-model="dialog.informations.model" width="500">
        <v-card>
          <v-card-title>Informations</v-card-title>
          <v-card-text>
            <p v-html="textePopup"></p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog.informations.model = false"
            >
              Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div
        v-if="!$storeDemandeBourse.TokenExtranet && CandidatureFermee == true"
        class="message-page"
      >
        <CandidatureFermee />
      </div>
      <div v-else-if="!$storeDemandeBourse.TokenExtranet && $storeDemandeBourse.DonneesFormulaire.TypeContactAutorise === false" class="message-page">
        <TypeContactNonAutorise />
      </div>
      <div v-else-if="NonAutorise == true" class="message-page">
        <PageNonAutorise />
      </div>
      <div v-else-if="DemandeExistante == true" class="message-page">
        <DemandeExistante />
      </div>
      <div v-else-if="Renouvellement == true" class="message-page">
        <CandidatureDejaRetenue />
      </div>
      <div
        v-if="
          !$storeDemandeBourse.DonneesFormulaire.EncryptId &&
          $storeDemandeBourse.TokenExtranet
        "
      >
        <div
          v-if="$storeDemandeBourse.DonneesFormulaire.TypeContactAutorise === false"
        >
          <TypeContactNonAutorise />
        </div >
        <h2 v-else-if="!CandidatureFermee && $storeDemandeBourse.DonneesFormulaire.TypeContactAutorise !== false">
          Merci de vous rediriger vers
          <a
            href="https://firsi-um6p.eudonet.com/SPECIF/EUDO_07846/formulaires/#/bourse"
            target="_blank"
            >ce lien</a
          >
          afin de créer votre candidature de bourse.
        </h2>
        <h2 v-else>
          Vous n'avez pas de candidature de bourse et la période de demande est
          close.
        </h2>
      </div>
      <div>
        <div
          id="verif_cni"
          v-if="
            acces_formulaire == false &&
            DemandeExistante == false &&
            Renouvellement == false &&
            CandidatureFermee == false &&
            NonAutorise == false &&
            !$storeDemandeBourse.TokenExtranet
          "
        >
          <v-row>
            <v-col cols="12">
              <div class="justify-center">
                <v-card :elevation="elev">
                  <v-card-title>
                    <h2>Merci de renseigner votre numéro CNI</h2>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="8">
                        <v-text-field
                          label="Numéro de CNI"
                          v-model="$storeDemandeBourse.DonneesFormulaire.Cni"
                        />
                      </v-col>
                      <v-col cols="4">
                        <v-btn
                          x-large
                          dark
                          color="secondary"
                          @click.native="CheckCni()"
                          >Vérifier</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions> </v-card-actions>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-stepper
          v-model="e1"
          class="stepper_bourse"
          v-if="acces_formulaire == true"
        >
          <v-row>
            <v-col cols="3">
              <v-row v-if="$storeDemandeBourse.TokenExtranet">
                <v-col cols="12">
                  <v-img
                    src="@/assets/FIRSILOGO.png"
                    contain
                    max-height="50"
                    max-width="150"
                    class="mr-2"
                  ></v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h5
                    v-show="
                      $storeDemandeBourse.DonneesFormulaire.EncryptId != null
                    "
                  >
                    Statut de votre dossier :
                    {{
                      $storeDemandeBourse.DonneesFormulaire.EtatDossier.Lang00
                    }}
                  </h5>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-stepper-header id="stepper-header">
                    <template v-for="(header, index) in $storeDemandeBourse.Headers">
                      <v-stepper-step
                      style="cursor:pointer;"
                      color="secondary"
                      :key="'stepper' + index"
                      :complete="e1 > index + 1"
                      :step="index + 1"
                      v-on:click="suivant(index+1)"
                      >
                        {{ header }}
                      </v-stepper-step>
                      <v-divider :key="'divider' + index" />
                    </template>
                  </v-stepper-header>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="content-stepper" cols="9">
              <v-row class="v-stepper-content" id="stepper-content">
                <v-col cols="12">
                  <v-stepper-items>
                    <v-stepper-content step="1" class="scrollable">
                      <h2>Formulaire de candidature de bourse</h2>
                      <v-spacer></v-spacer>
                      <v-divider></v-divider>
                      <small>
                        Conformément à la loi 09-08, vous disposez d’un droit
                        d’accès, de rectification et d’opposition au traitement
                        de vos données personnelles. Ce traitement a été
                        autorisé par la CNDP sous le numéro A-PO-1511/2024.
                      </small>
                      <v-checkbox
                        :rules="$storeReglesBourse.obligatoire"
                        v-model="$storeDemandeBourse.DonneesFormulaire.ConditionsGenerales"
                        input-value="true"
                        :readonly="$storeDemandeBourse.ReadOnly"
                      >
                        <template v-slot:label>
                          <span>
                            Cochez ici pour accepter les
                            <a target="_blank" :href="LienRgpd" @click.stop>
                              conditions générales d'utilisation des données
                              personnelles</a
                            ></span
                          >
                        </template>
                      </v-checkbox>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="scrollable">
                      <v-card :elevation="elev">
                        <v-row>
                          <v-col cols="12">
                            <InfosPerso ref="refInfosPerso" />
                          </v-col>
                        </v-row>
                        <v-row v-if="$storeDemandeBourse.DonneesFormulaire.BeneficiaireAutreBourse === $storeCatalogue.DataId.Oui">
                          <v-col cols="12">
                            <AutresBourses />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <AutresRevenusCandidat
                              ref="refAutresRevenusCandidat"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-stepper-content>
                    <v-stepper-content step="3" class="scrollable">
                      <h2>Parcours académique</h2>
                      <v-expansion-panels
                        multiple
                        v-model="Panel.ParcoursAcademique"
                      >
                        <v-expansion-panel ref="bac">
                          <v-expansion-panel-header>
                            <h3>Baccalauréat</h3>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="panel-content">
                            <Baccalaureat ref="refBaccalaureat" />
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel ref="cpge">
                          <v-expansion-panel-header>
                            <h3>Parcours CPGE</h3>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ParcoursCpge ref="refParcoursCpge" />
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-stepper-content>
                    <v-stepper-content step="4" class="scrollable">
                      <h2>Concours Grandes Ecoles ciblés</h2>
                      <ConcoursCibles ref="refConcoursCibles" />
                    </v-stepper-content>
                    <v-stepper-content step="5" class="scrollable">
                      <v-dialog v-model="dialog.tuteur.model" width="500">
                        <v-card class="text-center">
                          <v-card-title class="justify-center">
                            <h3>Informations</h3>
                          </v-card-title>
                          <v-card-text>
                            <h5>
                              {{ dialog.tuteur.texte }}
                            </h5>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              text
                              @click="dialog.tuteur.model = false"
                            >
                              Fermer
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <h2>Situation familiale</h2>
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <h3>Fratrie</h3>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="panel-content">
                            <CFratrie ref="refCFratrie" />
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel
                          v-show="
                            $storeDemandeBourse.DonneesFormulaire
                              .ProtectionSociale != $storeCatalogue.DataId.Oui
                          "
                        >
                          <v-expansion-panel-header>
                            <h3>Parents/Tuteur</h3>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ParentsTuteurs ref="refParentsTuteurs" />
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-stepper-content>
                    <v-stepper-content
                      :step="
                        $storeDemandeBourse.DonneesFormulaire
                          .ProtectionSociale != $storeCatalogue.DataId.Oui
                          ? 6
                          : 99
                      "
                      class="scrollable"
                    >
                      <Revenus ref="refRevenus" />
                    </v-stepper-content>
                    <v-stepper-content
                      :step="
                        $storeDemandeBourse.DonneesFormulaire
                          .ProtectionSociale != $storeCatalogue.DataId.Oui
                          ? 7
                          : 6
                      "
                      class="scrollable"
                    >
                      <div class="text-center">
                        <v-dialog
                          v-model="dialog.publipostage.model"
                          width="500"
                        >
                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              Résumé de votre candidature
                            </v-card-title>
                            <v-card-text>
                              <PublipostageCandidature />
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                text
                                @click="dialog.publipostage.model = false"
                              >
                                Annuler
                              </v-btn>
                              <v-btn 
                              color="primary" 
                              text 
                              :disabled="!this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne.DonneePieceJointe"
                              @click="SignerClick">
                                Enregistrer
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                      <h1>Finalisation</h1>
                      <span class="h7">
                        Une seule candidature est acceptée.
                      </span>
                      <br />
                      <span
                        v-if="!$storeDemandeBourse.DonneesFormulaire.EncryptId"
                        class="h7"
                      >
                        En cliquant sur "Enregistrer", votre demande sera
                        enregistrée et un mail avec vos accès à un espace
                        personnel vous sera envoyé. Depuis cet espace personnel,
                        vous pourrez modifier/compléter ou enregistrer
                        définitivement cette demande.
                      </span>
                      <span v-else class="h7">
                        Vous pouvez Enregistrer les nouvelles modifications
                        apportées à votre demande soit : <br />
                        - En cliquant sur "Enregistrer" : vous pourrez revenir
                        sur votre demande pour la modifier <br />
                        - En cliquant sur "Soumettre à la FIRSI" : Vous devrez
                        télécharger et signer le récapitulatif de votre demande
                        puis vous validerez définitivement votre demande et ne
                        pourrez plus la modifier.
                      </span>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row
                class="btn-stepper"
                v-if="e1 < $storeDemandeBourse.Headers.length + 1"
              >
                <v-col md="6" v-if="e1 > 1">
                  <v-btn
                    x-large
                    dark
                    color="secondary"
                    @click.native="precedent()"
                    >Précédent</v-btn
                  >
                </v-col>
                <v-col
                  :md="buttonRowColsize"
                  :class="buttonRowAlign"
                  v-if="e1 < $storeDemandeBourse.Headers.length"
                >
                  <v-btn
                    x-large
                    dark
                    color="secondary"
                    :disabled="e1 === 1 && !this.$storeDemandeBourse.DonneesFormulaire.ConditionsGenerales ? true : false"
                    @click.native="suivant(e1+1)"
                    >Suivant</v-btn
                  >
                </v-col>
                <v-col md="6" class="text-right" v-else>
                  <v-row>
                    <v-col cols="6">
                      <v-btn
                        x-large
                        dark
                        v-show="
                          $storeDemandeBourse.DonneesFormulaire.EncryptId &&
                          !$storeDemandeBourse.ReadOnly
                        "
                        color="secondary"
                        @click.native="validerDef()"
                      >
                        Soumettre</v-btn
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-btn
                        x-large
                        dark
                        color="secondary"
                        v-show="!$storeDemandeBourse.ReadOnly"
                        @click.native="saveForm()"
                        >Enregistrer</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper>
      </div>
    </v-main>
    <div v-else>
      <div style="min-height: 70vh" class="text-center">
        <v-card>
          <v-card-title class="justify-center">Confirmation</v-card-title>
          <v-card-text>
            <h5>
              Votre demande a bien été enregistrée. Vous recevrez un mail de
              confirmation.
            </h5>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import CFratrie from "@/components/Commun/Fratrie";
import InfosPerso from "@/components/CandidatureBourse/InformationsPerso";
import Baccalaureat from "@/components/CandidatureBourse/Baccalaureat";
import ParcoursCpge from "@/components/CandidatureBourse/ParcoursCpge";
import ConcoursCibles from "@/components/CandidatureBourse/ConcoursCibles";
import ParentsTuteurs from "@/components/Commun/ParentsTuteurs";
import Revenus from "@/components/Commun/Revenus";
import AutresRevenusCandidat from "@/components/Commun/AutresRevenusCandidat";
import AutresBourses from "@/components/Commun/AutresBourses";
import CandidatureFermee from "@/components/CandidatureBourse/CandidatureFermee";
import PageNonAutorise from "@/components/PageNonAutoriseExtranet";
import DemandeExistante from "@/components/CandidatureBourse/DemandeExistante";
import CandidatureDejaRetenue from "@/components/CandidatureBourse/CandidatureDejaRetenue";
import PublipostageCandidature from "@/components/CandidatureBourse/PublipostageCandidature";
import TypeContactNonAutorise from "@/components/CandidatureBourse/TypeContactNonAutorise";

export default {
  name: "DemandeBourse",
  components: {
    CFratrie,
    InfosPerso,
    Baccalaureat,
    ParcoursCpge,
    ConcoursCibles,
    ParentsTuteurs,
    Revenus,
    AutresRevenusCandidat,
    AutresBourses,
    CandidatureFermee,
    DemandeExistante,
    CandidatureDejaRetenue,
    TypeContactNonAutorise,
    PublipostageCandidature,
    PageNonAutorise,
  },

  data() {
    return {
      Panel: {
        ParcoursAcademique: [0, 1],
      },
      ListeErreurs: [],
      confirmation: false,
      dialog: {
        publipostage: {
          model: false,
        },
        informations: {
          model: false,
        },
        tuteur: {
          model: false,
          texte: "",
        },
      },
      $storeCatalogue: this.$storeCatalogue,
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeCommun: this.$storeCommun,
      LienRgpd: null,
      Etapes: {
        Un: "Introduction",
        Deux: "Informations personnelles",
        Trois: "Parcours académique",
        Quatre: "Concours grandes écoles ciblés",
        Cinq: "Situation familiale",
        Six: "Revenus",
        Sept: "Pour finir",
      },
      edit: false,
      acces_formulaire: false,
      erreur: "",
      textePopup: "",
      e1: 1,
      elev: 2,
      CandidatureFermee: false,
      NonAutorise: true,
      DemandeExistante: false,
      Renouvellement: false,
      ShowTuteur: this.$storeCommun.NombreTuteurs > 0,
      loader: true,
    };
  },
  computed: {
    buttonRowColsize() {
      if (this.e1 === 1) {
        return 12;
      } else {
        return 6;
      }
    },
    buttonRowAlign() {
      if (this.e1 === 1) {
        return "text-center";
      } else {
        return "text-right";
      }
    },
  },
  watch: {},
  methods: {
    CheckCni() {
      if (this.$storeDemandeBourse.DonneesFormulaire.Cni) {
        var self = this;
        this.loader = true;

        Promise.all([
          this.$storeDemandeBourse
            .CheckCni(this.$storeDemandeBourse.DonneesFormulaire.Cni)
            .then((response) => {
              if (response.data) {
                this.$storeDemandeBourse.DonneesFormulaire.CandidatureRenouvellement =
                  response.data.candidatureRenouvellement;
                this.$storeDemandeBourse.DonneesFormulaire.Programmes =
                  response.data.programmes;
                this.$storeDemandeBourse.DonneesFormulaire.EncryptId =
                  response.data.encryptId;
                this.$storeDemandeBourse.DonneesFormulaire.TypeContactAutorise =
                  response.data.typeContactAutorise;
              }
            })
            .catch(function (error) {
              if (error) {
                this.textePopup = "Une erreur est survenue";
                this.dialog.informations.model = true;
                console.log(error);
              }
            }),
        ]).then(function () {
          self.loader = false;
          if (
            self.$storeDemandeBourse.DonneesFormulaire.Programmes.length > 0
          ) {
            if (
              self.$storeDemandeBourse.DonneesFormulaire
                .CandidatureRenouvellement
            ) {
              self.Renouvellement = true;
            } else if (
              !self.$storeDemandeBourse.TokenExtranet &&
              self.$storeDemandeBourse.DonneesFormulaire.EncryptId
            ) {
              // si on n'a pas de token mais qu'on a bien une candidature, on informe le candidat qu'il doit se connecter à son extranet
              self.DemandeExistante = true;
            } else if (
              self.$storeDemandeBourse.DonneesFormulaire.TypeContactAutorise === false
            ) {
              // Type de contact non autorisé - afficher le message approprié
              self.NonAutorise = true;
            } else {
              self.acces_formulaire = true;
            }
          } else if (
            self.$storeDemandeBourse.DonneesFormulaire.TypeContactAutorise === false
          ) {
            // Type de contact non autorisé même sans programmes
            self.NonAutorise = true;
          }
        });
      } else {
        this.textePopup = "Veuillez renseigner un numéro de CNI";
        this.dialog.informations.model = true;
      }
    },
    async saveForm() {
      // Vérifier les champs obligatoires
      let listeErreurs = [];
      if (!this.$storeDemandeBourse.DonneesFormulaire.Nom) {
        listeErreurs.push("Nom");
      }
      if (!this.$storeDemandeBourse.DonneesFormulaire.Prenom) {
        listeErreurs.push("Prenom");
      }
      if (!this.$storeDemandeBourse.DonneesFormulaire.Cni) {
        listeErreurs.push("Numéro CNI");
      }
      if (!this.$storeDemandeBourse.DonneesFormulaire.Email) {
        listeErreurs.push("Email");
      }
      if (!this.$storeDemandeBourse.DonneesFormulaire.AnneeScolaireCpge) {
        listeErreurs.push("Parcours CPGE - Année scolaire");
      }
      if (!this.$storeDemandeBourse.DonneesFormulaire.AnneeCpge) {
        listeErreurs.push("Parcours CPGE - Année CPGE");
      }
      if (!this.$storeDemandeBourse.DonneesFormulaire.FiliereAnnee2) {
        listeErreurs.push("Parcours CPGE - Filière");
      }
      if (!this.$storeDemandeBourse.DonneesFormulaire.EtablissementCpge) {
        listeErreurs.push("Parcours CPGE - Etablissement");
      }
      if (
        !this.$storeCommun.InfosCandidature
          .ProprietaireDeBiensImmobiliersSecondaire
      ) {
        listeErreurs.push("Propriétaire de biens Immobiliers - Candidat");
      }
      if (
        this.$storeDemandeBourse.DonneesFormulaire.ListeConcoursCibles.filter(
          (c) => {
            return !c.Supprimer;
          }
        ).length == 0
      ) {
        listeErreurs.push("Ajouter au moins un concours");
      }
      if (
        (!this.$storeDemandeBourse.DonneesFormulaire.AdrPrincipale ||
          !this.$storeDemandeBourse.DonneesFormulaire.CodePostalAdrPrincipale ||
          !this.$storeDemandeBourse.DonneesFormulaire.VilleAdrPrincipale ||
          !this.$storeDemandeBourse.DonneesFormulaire.ProvinceMaroc ||
          !this.$storeDemandeBourse.DonneesFormulaire.RegionMaroc) &&
        (!this.$storeDemandeBourse.DonneesFormulaire.PaysAutreAdresse ||
          !this.$storeDemandeBourse.DonneesFormulaire.AutreAdresse ||
          !this.$storeDemandeBourse.DonneesFormulaire.CodePostalAutreAdresse ||
          !this.$storeDemandeBourse.DonneesFormulaire.VilleAutreAdresse)
      ) {
        listeErreurs.push("Ajouter au moins une adresse");
      }
      // Parcours académique 1ere année
      if (
        this.$storeDemandeBourse.DonneesFormulaire.ListeParcoursCpge.filter(
          (c) => {
            return (
              !c.Supprimer &&
              c.AnneeCpge == this.$storeCatalogue.DataId.PremiereAnneeCpge
            );
          }
        ).length == 0
      ) {
        listeErreurs.push(
          "Parcours académique - Ajouter votre 1ere année CPGE"
        );
      }

      // tuteur
      if(this.$storeDemandeBourse.DonneesFormulaire.ProtectionSociale !=
          this.$storeCatalogue.DataId.Oui &&
        this.$storeCommun.NombreTuteurs < 1){
          listeErreurs.push("Ajoutez au moins un tuteur");
        }

      if (listeErreurs.length > 0) {
        this.textePopup =
          "Veuillez renseigner les informations suivantes : <br>";
        listeErreurs.forEach((item) => {
          this.textePopup += item + "<br>";
        });
        this.dialog.informations.model = true;
        return;
      }

      this.$storeDemandeBourse.AffecterStoreCommun(this.$storeCommun);
      this.loader = true;
      const reponse = await
        this.$storeDemandeBourse
          .EnregistrerDemande(
            this.$storeDemandeBourse.TokenExtranet,
            this.$storeDemandeBourse.DonneesFormulaire
          );

      if(reponse != "error"){
        // si on est connecté sur l'extranet, alors on met à jour les infos de la demande.
        if (this.$storeDemandeBourse.TokenExtranet) {
          this.$storeDemandeBourse.MapperDtoEnDonneesFormulaire(
            reponse,
            this.$storeCommun
          );
          this.textePopup = "Modifications enregistrées.";
          this.dialog.informations.model = true;
        } else {
          this.confirmation = true;
        }
      }
      else{
        this.textePopup = "Une erreur est survenue";
        this.dialog.informations.model = true;
      }

      this.loader = false;
    },
    async SignerClick() {
      if (!this.$storeDemandeBourse.DonneesFormulaire.PublipostageSigne.DonneePieceJointe) {
        let erreur = ["Veuillez ajouter le résumé signé"];
        this.AfficherListeErreurs(erreur);
        return;
      }
      this.$storeDemandeBourse.AffecterStoreCommun(this.$storeCommun);
      this.loader = true;

      const reponse = await this.$storeDemandeBourse
          .ValiderDemande(
            this.$storeDemandeBourse.TokenExtranet,
            this.$storeDemandeBourse.DonneesFormulaire
          );

      if(reponse != "error"){
        this.textePopup = "Votre demande a bien été enregistrée";
        this.dialog.informations.model = true;
        this.$storeDemandeBourse.MapperDtoEnDonneesFormulaire(
          reponse,
          this.$storeCommun
        );
      }
      else{
        this.textePopup = "Une erreur est survenue";
        this.dialog.informations.model = true;
      }

      this.loader = false;
      this.dialog.publipostage.model = false;
    },
    async validerDef() {
      this.$storeDemandeBourse.AffecterStoreCommun(this.$storeCommun);
      this.loader = true;

      const reponse = await this.$storeDemandeBourse
                  .EnregistrerDemande(
                    this.$storeDemandeBourse.TokenExtranet,
                    this.$storeDemandeBourse.DonneesFormulaire
                  );
      
      if(reponse != "error"){
        // si on est connecté sur l'extranet, alors on met à jour les infos de la demande.
        if (this.$storeDemandeBourse.TokenExtranet) {
          this.$storeDemandeBourse.MapperDtoEnDonneesFormulaire(
            reponse,
            this.$storeCommun
          );
          let listeErreurs = this.ChampsObligatoireSoumission();
          if (listeErreurs.length > 0) {
            this.AfficherListeErreurs(listeErreurs);
            this.loader = false;
            return;
          } else {
            this.PubliposterCandidature();
          }
        }
      }
      else{
        this.textePopup = "Une erreur est survenue";
        this.dialog.informations.model = true;
        this.loader = false;
      }
    },
    PubliposterCandidature() {
      var self = this;
      this.loader = true;
      Promise.all([
        this.$storeDemandeBourse
          .PubliposterCandidature(this.$storeDemandeBourse.TokenExtranet)
          .then((response) => {
            if (response) {
              this.$storeDemandeBourse.DonneesFormulaire.ResumeCandidature =
                response.data;
            }
          })
          .catch(function (error) {
            if (error) {
              this.textePopup = "Une erreur est survenue";
              this.dialog.informations.model = true;
            }
          }),
      ]).then(function () {
        self.loader = false;
        self.dialog.publipostage.model = true;
      });
    },
    VerifierTuteurs(show) {
      this.$storeCommun.CountNombreTuteurs(this.$storeCommun.ListeSituationsFamiliale);
      
      if (
        this.$storeDemandeBourse.DonneesFormulaire.ProtectionSociale !=
          this.$storeCatalogue.DataId.Oui &&
        this.$storeCommun.NombreTuteurs < 1 
      ) {
        if (show) {
          this.dialog.tuteur.model = true;
          this.dialog.tuteur.texte =
            "Merci de renseigner au moins un tuteur. Auquel cas, merci de revenir à l'étape 'Informations personnelles' et de répondre oui à la question 'Provenez-vous d'un établissement social ?'";
        }
        return false;
      }

      let nbTuteurPere = this.$storeCommun.NombreTuteurParente(this.$storeCatalogue.DataId.ParentePere, this.$storeCatalogue.DataId.Oui);
      let nbTuteurMere = this.$storeCommun.NombreTuteurParente(this.$storeCatalogue.DataId.ParenteMere, this.$storeCatalogue.DataId.Oui);

      if(this.$storeDemandeBourse.DonneesFormulaire.ProtectionSociale !== this.$storeCatalogue.DataId.Oui 
      && (this.$storeCommun.InfosCandidature.EtesVous ===
          this.$storeCatalogue.DataId.ChargeUnParentVeuf
        || this.$storeCommun.InfosCandidature.EtesVous ===
          this.$storeCatalogue.DataId.ChargeUnParentDivorce)
      && this.$storeCommun.InfosCandidature.ChargeUnParent)
      {
        if((this.$storeCommun.InfosCandidature.ChargeUnParent === this.$storeCatalogue.DataId.GardeMere
          || this.$storeCommun.InfosCandidature.ChargeUnParent === this.$storeCatalogue.DataId.TutelleMere)
          && (nbTuteurMere < 1 || nbTuteurPere > 0)
        )
        {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
              "Vous avez indiqué être à la charge de votre mère, merci de vérifier votre saisie.";
          }
          return false;
        }
         if((this.$storeCommun.InfosCandidature.ChargeUnParent === this.$storeCatalogue.DataId.GardePere
          || this.$storeCommun.InfosCandidature.ChargeUnParent === this.$storeCatalogue.DataId.TutellePere)
          && (nbTuteurPere < 1 || nbTuteurMere > 0)
        )
        {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
              "Vous avez indiqué être à la charge de votre père, merci de vérifier votre saisie.";
          }
          return false;
        }
      }
      if (
        this.$storeCommun.InfosCandidature.EtesVous &&
        this.$storeCommun.InfosCandidature.EtesVous ==
          this.$storeCatalogue.DataId.ChargeDeuxParentsMaries &&
        this.$storeDemandeBourse.DonneesFormulaire.ProtectionSociale &&
        this.$storeDemandeBourse.DonneesFormulaire.ProtectionSociale ==
          this.$storeCatalogue.DataId.Non
      ) {
        if (this.$storeCommun.NombreTuteurs < 2) {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
              "Vous avez indiqué être à la charge de deux parents mariés, merci d'ajouter ici vos deux parents.";
          }
          return false;
        }
        let parentsMaries = this.$storeCommun.NombreParentParStatutParentTuteur(this.$storeCatalogue.SituationFamMarie, this.$storeCatalogue.DataId.Oui);
        
        if (
          parentsMaries < 2 &&
          this.$storeDemandeBourse.DonneesFormulaire.ProtectionSociale &&
          this.$storeDemandeBourse.DonneesFormulaire.ProtectionSociale ==
            this.$storeCatalogue.DataId.Non
        ) {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
              "Vous avez indiqué être à la charge de deux parents mariés, merci de corriger la situation familiale de vos parents.";
          }
          return false;
        }
      }

      return true;
    },
    // Passe à l'etape precedente
    precedent() {
      if (
        this.$storeDemandeBourse.TokenExtranet &&
        !this.$storeDemandeBourse.ReadOnly
      ) {
        this.$storeDemandeBourse.AffecterStoreCommun(this.$storeCommun);
        var self = this;
        this.loader = true;
        Promise.all([
          this.$storeDemandeBourse
            .SaveEtape(this.e1)
            .then((reponse) => {
              if (reponse && reponse.data) {
                this.$storeDemandeBourse.MapperDtoEnDonneesFormulaire(
                  reponse.data,
                  this.$storeCommun
                );
              }
            })
            .catch(function (error) {
              if (error) {
                this.textePopup = "Une erreur est survenue";
                this.dialog.informations.model = true;
              }
            }),
        ]).then(function () {
          self.loader = false;
          self.e1--;
          window.scrollTo(0, 0);
        });
      } else {
        this.e1--;
        window.scrollTo(0, 0);
      }
    },
    // Passe à l'etape suivate
    async suivant(etapeCible) {
      if(!this.$storeDemandeBourse.ReadOnly){
        if(this.e1
          && !this.$storeDemandeBourse.DonneesFormulaire.ConditionsGenerales
        ){
          return;
        }

        // On vérifie les tuteurs qu'on soit dans le formulaire hors extranet ou connecté extranet.
        if (this.e1 == 5 
        && !this.$storeDemandeBourse.ReadOnly 
        && etapeCible > this.e1) {
          let test = this.VerifierTuteurs(true);
          if (!test) {
            return;
          }
        }

        if(this.$storeDemandeBourse.TokenExtranet){
          this.$storeDemandeBourse.AffecterStoreCommun(this.$storeCommun);
          this.loader = true;
          const reponse = await this.$storeDemandeBourse.SaveEtape(this.e1);
          if(reponse != "error"){
            this.$storeDemandeBourse.MapperDtoEnDonneesFormulaire(reponse, this.$storeCommun);
            this.loader = false;

            // Verifier étape.
            let etapeFinale = etapeCible;
            let listeErreurs = [];
            // Vérifier les champs obligatoires pour chaque étapes entre l'étape actuelle et l'étape demandée.
            for(let i = this.e1; i < etapeFinale; i++){
              if(i === 2){
                listeErreurs = this.$refs.refInfosPerso.ValiderForm();
                listeErreurs = [...listeErreurs, ...this.$refs.refAutresRevenusCandidat.ValiderForm()];
              }
              else if(i === 3){
                let bac = this.$refs.refBaccalaureat.ValiderForm();
                let cpge = this.$refs.refParcoursCpge.ValiderForm();
                let cpge1Annee = this.ErreurCpge1Annee();

                if(bac.length > 0 
                  || cpge.length > 0
                  || cpge1Annee === true
                )
                {
                  listeErreurs.push("Parcours académique");
                }

              }
              else if(i === 4){
                if(this.ErreurConcours()){
                  listeErreurs.push("Concours");
                }
              }
              else if(i === 5){
                if(!this.VerifierTuteurs(true)){
                  listeErreurs.push("Ajoutez au moins un tuteurs");
                }
              }
              else if(i === 6){
                listeErreurs = this.$refs.refRevenus.ValiderForm();
              }

              if(listeErreurs.length > 0){
                etapeFinale = i;
              }
            }

            this.e1 = etapeFinale;
          }
          else{
            this.textePopup = "Une erreur est survenue";
            this.dialog.informations.model = true;
            this.loader = false;
          }
        }
        else{
          this.e1 = etapeCible;
        }
      }
      else{
        this.e1 = etapeCible;
      }
    },
    PushListeErreur(nomEtape, liste) {
      if (liste != undefined && liste.length > 0) {
        if (nomEtape && nomEtape.length > 0) {
          this.ListeErreurs.push(nomEtape);
        }

        liste.forEach((e) => {
          this.ListeErreurs.push("- " + e);
        });
      }
    },
    ChampsObligatoireSoumission() {
      this.ListeErreurs = [];

      // Etape 2 : Informations personnelles + autres revenus candidat.
      this.PushListeErreur(
        "Informations personnelles : ",
        this.$refs.refInfosPerso.ValiderForm()
      );
      this.PushListeErreur(
        "",
        this.$refs.refAutresRevenusCandidat.ValiderForm()
      );

      // Etape 3 Parcours académique : Baccalauréat + CPGE
      this.PushListeErreur(
        "Parcours académique - Baccalauréat : ",
        this.$refs.refBaccalaureat.ValiderForm()
      );
      this.PushListeErreur(
        "Parcours académique - Parcours CPGE : ",
        this.$refs.refParcoursCpge.ValiderForm()
      );
      // Parcours académique 1ere année
      if(this.ErreurCpge1Annee()){
        this.ListeErreurs.push("Parcours académique - Ajouter votre 1ere année CPGE");
      }

      // Etape 4 : Concours
      if(this.ErreurConcours()){
        this.ListeErreurs.push("Ajouter au moins un Concours Grande Ecole");
      }

      // Etape 5 : Tuteur.
      if(!this.VerifierTuteurs(false)){
        this.ListeErreurs.push("Situation familiale : vérifier la situation familiale");
      }

      // Etape 6 : Revenus.
      this.PushListeErreur("Revenus : ", this.$refs.refRevenus.ValiderForm());

      // Annexes
      if (
        this.$storeDemandeBourse.DonneesFormulaire.ListeAnnexesFirsi.filter(
          (item) => {
            return item.ObligatoireSoumettre == true && !item.NomFichier;
          }
        ).length > 0
      ) {
        this.ListeErreurs.push(
          "Annexes - Veuillez ajouter toutes les annexes obligatoires"
        );
      }

      return this.ListeErreurs;
    },
    AfficherListeErreurs(listeErreurs) {
      if (listeErreurs && listeErreurs.length > 0) {
        this.textePopup =
          "Veuillez renseigner les informations suivantes : <br>";
        listeErreurs.forEach((item) => {
          this.textePopup += item + "<br>";
        });
        this.dialog.informations.model = true;
        return;
      }
    },
    ErreurCpge1Annee(){
      if (
        this.$storeDemandeBourse.DonneesFormulaire.ListeParcoursCpge.filter(
          (c) => {
            return (
              !c.Supprimer &&
              c.AnneeCpge == this.$storeCatalogue.DataId.PremiereAnneeCpge
            );
          }
        ).length == 0
      ) {
        return true;
      }
      return false;
    },
    ErreurConcours(){
      if (
        this.$storeDemandeBourse.DonneesFormulaire.ListeConcoursCibles.filter(
          (c) => {
            return !c.Supprimer;
          }
        ).length == 0
      ) {
        return true;
      }
      else {
        return false;
      }
    },
  },
  created() {
    document.title = "Demande de bourse";
    const baseurl = process.env.VUE_APP_FORMULAIRES;
    var link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.rel = "icon";
    link.href = baseurl + "favicon.svg";
    document.getElementsByTagName("head")[0].appendChild(link);
  },
  mounted() {
    this.LienRgpd = process.env.VUE_APP_URL_CNDP;
    var self = this;
    if (!this.$route.query.t) {
      this.NonAutorise = false;
      Promise.all([
        this.$storeDemandeBourse
          .ChargementFormulaire()
          .then((response) => {
            if (response) {
              this.$storeDemandeBourse.DonneesFormulaire.EncryptId =
                response.data.encryptId;
              this.$storeDemandeBourse.DonneesFormulaire.PpId =
                response.data.ppid;
              this.$storeCommun.DateAgeFratrie = response.data.dateAgeFratrie;
              this.$storeCommun.AnneeRevenus = response.data.anneeScolaireAutresRevenus?.lang00;
              this.$storeDemandeBourse.DonneesFormulaire.Erreur =
                response.data.erreur;
              this.$storeDemandeBourse.LienDocumentDgi =
                response.data.lienDocumentDgi;
              this.$storeDemandeBourse.LienDocumentSalaire =
                response.data.lienDocumentSalaire;
              this.CandidatureFermee = response.data.formulaireFerme;
            }
          })
          .catch(function (error) {
            if (error) {
              this.textePopup = "Une erreur est survenue";
              this.dialog.informations.model = true;
            }
          }),
        this.$storeCatalogue.ChargerCataloguesCandidatureBourse(),
      ]).then(function () {
        self.loader = false;
      });
    } else {
      let nid = this.$route.query.nid;
      this.$storeDemandeBourse.TokenExtranet = this.$route.query.t;
      this.$storeDemandeBourse.TokenExtranet =
        this.$storeDemandeBourse.TokenExtranet.replace(/\s/g, "+");
      // Vérif token
      Promise.all([
        this.$storeDemandeBourse
          .ChargementFormulaire(this.$storeDemandeBourse.TokenExtranet, nid)
          .then((reponse) => {
            if (reponse && reponse.data) {
              this.NonAutorise = !reponse.data.autorise;
              this.CandidatureFermee = reponse.data.formulaireFerme;

              if (!this.NonAutorise && reponse.data.encryptId) {
                this.$storeDemandeBourse.MapperDtoEnDonneesFormulaire(
                  reponse.data,
                  this.$storeCommun
                );
                this.$storeDemandeBourse.DonneesFormulaire.ConditionsGenerales = true;
                this.$storeDemandeBourse.LienDocumentDgi =
                  reponse.data.lienDocumentDgi;
                this.$storeDemandeBourse.LienDocumentSalaire =
                  reponse.data.lienDocumentSalaire;
                this.$storeDemandeBourse.DonneesFormulaire.Programmes =
                  reponse.data.programmes;
                this.$storeCommun.DateAgeFratrie = reponse.data.dateAgeFratrie;
                this.acces_formulaire = true;
              } else {
                console.log(
                  "Vous n'avez pas de candidature de bourse et la date de candidature de bourse est close."
                );
              }
            } else {
              console.log("pas reponse");
            }
          })
          .catch(function (error) {
            if (error) {
              console.log(error);
              self.textePopup = "Une erreur est survenue";
              self.dialog.informations.model = true;
            }
          }),
        this.$storeCatalogue.ChargerCataloguesCandidatureBourse(),
      ]).then(function () {
        self.loader = false;
      });
    }
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
